import React from 'react';
import {Link} from 'react-router';
import fileDownload from 'js-file-download';
import {ShowIf} from 'components/utils';
import {checkServerLive} from 'constants/config';
import {downloadFile} from 'components/utils';

export default class RowItemDocumentDetail extends React.Component {
  render() {
    return (
      <tr>
        <td>{this.props.count}</td>
        <td>{this.props.item.ten}</td>
        <td>{this.props.item.tinhTrangTaiLieuStr ? this.props.item.tinhTrangTaiLieuStr : ''}</td>
        <td className="none-boder underline-name">
          <ShowIf condition={!checkServerLive}>
            <Link onClick={fileDownload.bind(this, this.props.item.duongDan, this.props.item.tenFile)}>{this.props.item.tenFile}</Link>
          </ShowIf>
          <ShowIf condition={checkServerLive}>
            <Link onClick={()=>{downloadFile(this.props.item.duongDan, this.props.item.tenFile)}}>{this.props.item.tenFile}</Link>
          </ShowIf>
        </td>
      </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/modules/reception/datatable/detail/RowItemDocumentDetail.jsx